import React from 'react';
import { FieldProps } from 'formik';
import DateRangePicker, { CustomDateRangePickerProps } from '@/components/shared/DateRangePicker';

export interface DateRangePickerProps extends FieldProps, CustomDateRangePickerProps {
  data: any;
}

function DateRangePickerField({ field, form, onChange, ...props }: DateRangePickerProps) {
  return (
    <div className="formik-date-range">
      <DateRangePicker
        name={field.name}
        value={field.value}
        onChange={(value) => {
          onChange?.(value);
          form.setFieldValue(field.name, value);
        }}
        {...props}
      />
    </div>
  );
}
export default DateRangePickerField;
